import React from 'react';
import styled from 'styled-components';

import { CrossIcon, PlayIcon } from '@kespa/ui';
import Modal from 'react-modal';

import { SignupForm } from './SignupForm';

Modal.defaultStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        backgroundColor: 'rgba(255,255,255, 0.9)',
    },
    content: {},
};

export const StyledModalBody = styled.div`
    padding: 40px;
    width: 380px;
    max-width: 90vw;
    position: relative;
`;

export const StyledModalClose = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
    height: 40px;
    width: 40px;
    opacity: 0.2;
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
    svg {
        height: 40px;
        width: 40px;
    }
`;
export const ModalSignup = ({
    closeTimeoutMS,
    onRequestClose,
    isOpen,
    showBio,
    ...otherProps
}) => {
    return (
        <Modal
            closeTimeoutMS={closeTimeoutMS || 700}
            onRequestClose={onRequestClose}
            isOpen={isOpen}
            {...otherProps}
        >
            <StyledModalBody>
                <StyledModalClose onClick={onRequestClose}>
                    <CrossIcon />
                </StyledModalClose>
                <SignupForm showBio={showBio} />
            </StyledModalBody>
        </Modal>
    );
};
